import { Taxonomy } from '@zoopla/tracking';
import { RootState } from '@zoopla/redux-types';
import { TaxonomyState } from '@zoopla/redux-types';

const ADD_TAXONOMY = 'taxonomy/ADD_TAXONOMY';
interface AddTaxonomyAction {
    type?: typeof ADD_TAXONOMY;
    taxonomy: TaxonomyState;
}

type TaxonomyActionType = AddTaxonomyAction;

const initialState: TaxonomyState = {
    taxonomy: {} as Taxonomy
};

export const taxonomy = (
    state = initialState,
    action: TaxonomyActionType
): TaxonomyState => {
    switch (action.type) {
        case ADD_TAXONOMY:
            return {
                ...state,
                taxonomy: {
                    ...state.taxonomy,
                    ...action.taxonomy.taxonomy
                }
            };
    }

    return state;
};

export const addTaxonomy = (taxonomy: TaxonomyState): AddTaxonomyAction => ({
    type: ADD_TAXONOMY,
    taxonomy
});

export const selectTaxonomy = (
    state: Pick<RootState, 'taxonomy'>
): TaxonomyState => state.taxonomy;

export default taxonomy;
